/* Adjustable Shelf Brackets
    --mountType <string::enum> | ['Surface', 'In Wall', 'Hidden']
    --length <string>
    --loadWeight <float> | pounds
    --minShelfDepth <float> | inches
    --maxShelfDepth <float | inches | ('Good for shelves of depth X" to Y"')
*/
import { decimal } from 'vuelidate/lib/validators'

import { length } from '@/modules/standardItems/schemas/baseFormFields'
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'

export default [
  ...hardwareFormFields,
  {
    key: 'mountType',
    value: 'mountType',
    type: 'select',
    required: true,
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Mount Type',
      required: true,
      class: ['input--dense']
    },
    values: ['Surface', 'In Wall', 'Hidden']
  },
  length({ classes: ['xs12', 'sm4'] }),
  {
    key: 'loadWeight',
    value: 'loadWeight',
    type: 'float',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Load Weight',
      suffix: 'lbs',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'Load Weight should be a number'
      }
    ]
  },
  {
    key: 'minShelfDepth',
    value: 'minShelfDepth',
    type: 'float',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Min Shelf Depth',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  },
  {
    key: 'maxShelfDepth',
    value: 'maxShelfDepth',
    type: 'float',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Max Shelf Depth',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  }
]
